import { Toaster as Sonner, toast } from "sonner";

/**
 * Halalin: always light toasts to match the product shell (no next-themes provider in CRA).
 * closeButton: explicit dismiss; swipe-to-dismiss still works on touch.
 */
const Toaster = ({ theme = "light", closeButton = true, toastOptions, ...props }) => {
  return (
    <Sonner
      theme={theme}
      closeButton={closeButton}
      className="toaster group"
      toastOptions={{
        ...toastOptions,
        classNames: {
          // Do not set bg/border/text on the li — it fights Sonner `richColors` and causes square corners under rounded borders. Shadow comes from Sonner.
          toast: "group toast rounded-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton: "group-[.toast]:border-border group-[.toast]:bg-background group-[.toast]:text-foreground",
          ...toastOptions?.classNames,
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
